import { render, staticRenderFns } from "./SAndLGrid.vue?vue&type=template&id=0ed6a456&scoped=true&"
import script from "./SAndLGrid.vue?vue&type=script&lang=ts&"
export * from "./SAndLGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SAndLGrid.vue?vue&type=style&index=0&id=0ed6a456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed6a456",
  null
  
)

export default component.exports